import { Suspense, useEffect, useMemo, useRef, useState } from 'react';
import Image from 'next/legacy/image';
import { bgBlack } from 'next/dist/lib/picocolors';
import LoadNormalModal from '../ProductDown/DNormalModal';

type Props = {
  data: string[] | undefined;
  product: any;
  T3dUrl:string ;
};
export default function ImageGallery(props: Props) {
  const data = props.data;
  let T3dUrl=props.T3dUrl
  const product = props.product;
  const videoRef = useRef<HTMLVideoElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentImage = useMemo(() => {
    if (data) {
      return data[currentIndex];
    }
  }, [currentIndex, data]);
  const changeIndexAction = (index: number) => {
    setCurrentIndex(index);
    setis3D(false);
  };

  // 下方小轮播图的x轴位移距离
  const [currentTranslageX, setCurrentTranslageX] = useState(0);
  const preTransitionAction = () => {
    if (currentTranslageX < 0) {
      setCurrentTranslageX(currentTranslageX + 84);
    }
  };
  const nextTransitionAction = () => {
    if (data && currentTranslageX > (data.length - 5) * -84) {
      setCurrentTranslageX(currentTranslageX - 84);
    }
  };

  // 放大镜的宽高、水平和垂直方向的偏移量
  const [magnifyingGlassData, setMagnifyingGlassData] = useState({
    width: '200px',
    height: '200px',
    translateX: '0px',
    translateY: '0px',
  });
  const [bkData, setBkData] = useState({
    x: '-100px',
    y: '0px',
  });

  const currentImgBox = useRef<HTMLDivElement>(null);

  let throttleTimer: number | undefined;
  const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!throttleTimer) {
      throttleTimer = window.setTimeout(() => {
        throttleTimer = undefined;
        const magnifyingGlassWidth = parseInt(
          magnifyingGlassStyle.width.replace('px', '')
        );
        if (currentImgBox.current) {
          const imgBoxRect = currentImgBox.current.getBoundingClientRect();
          const x = event.clientX - imgBoxRect.left - magnifyingGlassWidth / 2;
          const y = event.clientY - imgBoxRect.top - magnifyingGlassWidth / 2;

          const maxX = currentImgBox.current.offsetWidth - magnifyingGlassWidth;
          const maxY =
            currentImgBox.current.offsetHeight - magnifyingGlassWidth;

          const clampedX = Math.min(Math.max(x, 0), maxX);
          const clampedY = Math.min(Math.max(y, 0), maxY);

          setMagnifyingGlassData({
            ...magnifyingGlassData,
            translateY: clampedY + 'px',
            translateX: clampedX + 'px',
          });

          setBkData({
            x: `${-clampedX * 2}px`,
            y: `${-clampedY * 2}px`,
          });
        }
      }, 10); // Adjust the throttle interval as needed (e.g., 100ms)
    }
  };

  // 放大镜样式
  const magnifyingGlassStyle = {
    width: '200px',
    height: '200px',
    translate: `${magnifyingGlassData.translateX} ${magnifyingGlassData.translateY}`,
  };

  // 放大的背景图样式
  const bkStyle = {
    backgroundPosition: `${bkData.x} ${bkData.y}`,
  };
  // /图片和视频变量
  const [isPlaying, setIsPlaying] = useState(false);
  // 3D
  const [is3D, setis3D] = useState(false);

  // console.log(T3dUrl,'T3dUrl');
  
  return (
    <div className="relative">
      <div className="select-none">
      <div
            className="border-2 mb-6 relative group z-[2] w-[400px] h-[400px]"
            ref={currentImgBox}
            onMouseMove={handleMouseMove}
          >
            {product?.video_url && currentIndex === 0 ? (
              <video
                ref={videoRef}
                className="w-full h-full object-cover"
                src={product.video_url}
                controls={false}
                autoPlay={false}
                muted={true}
                playsInline={true}
                loop={true}
                poster={currentImage || '/default.png'}
              />
            ) : (
              <Image
                src={currentImage || '/default.png'}
                width={400}
                height={400}
                alt={'加载失败'}
              ></Image>
            )}

            <div
              className="bg-[rgba(195,185,102,.3)] absolute top-0 left-0 hidden group-hover:block"
              style={magnifyingGlassStyle}
            ></div>
            <div className="absolute  w-[400px] h-[400px] overflow-hidden top-0 left-[410px] hidden group-hover:block">
              <div
                className="w-[800px] h-[800px]  bg-no-repeat bg-cover"
                style={{ backgroundImage: `url(${currentImage})`, ...bkStyle }}
              ></div>
            </div>
          </div>

        <div className="relative">
          <div className="w-[400px] overflow-hidden relative">
            <div
              className={`b-flex w-fit`}
              style={{ translate: `${currentTranslageX}px 0` }}
            >
              {data?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`relative w-[64px] h-[64px] bg-white mr-[20px] last:mr-0 border-2 cursor-pointer ${
                      currentIndex === index ? 'border-[#000]' : 'border-[#ccc]'
                    }`}
                    onClick={() => changeIndexAction(index)}
                  >
                    <Image
                      src={item}
                      width={80}
                      height={80}
                      alt={'加载失败'}
                    ></Image>
                    {product.video_url && index === 0 && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsPlaying(!isPlaying);
                          setis3D(false);
                          if (videoRef.current) {
                            if (isPlaying) {
                              videoRef.current.pause();
                            } else {
                              videoRef.current.play();
                            }
                          }
                        }}
                        className="absolute left-1/2 top-1/2 z-[99] flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-black/35 max-md:left-8"
                      >
                        <i
                          className={`${
                            isPlaying ? 'ri-pause-fill' : 'ri-play-fill'
                          } text-2xl text-white`}
                        ></i>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {data && data.length >= 6 && (
            <>
              <div
                className="absolute bottom-0 left-[-20px] h-full flex items-center text-2xl cursor-pointer"
                onClick={preTransitionAction}
              >
                <i className="ri-arrow-left-s-line "></i>
              </div>
              <div
                className="absolute bottom-0 right-[-20px] h-full flex items-center text-2xl cursor-pointer"
                onClick={nextTransitionAction}
              >
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

